import { combineReducers } from '@ngrx/store';

import { recentSearchesReducer as recentSearches } from '@recent-searches/store/reducers/recent-searches.reducer';

export const recentSearchesRootReducer = combineReducers({
  recentSearches
});
